function RankingSection() {
  const movies = [
    { rank: 1, title: '速度与激情10', en: 'Fast X', tag: '动作', hot: '9.8', desc: '唐老大再度集结，飙车家族迎来终极之战，肾上腺素爆表的视觉盛宴。' },
    { rank: 2, title: '封神第一部', en: 'Creation of the Gods I', tag: '奇幻', hot: '9.6', desc: '史诗级神话巨制，朝歌风云再起，殷商王朝的命运之战拉开帷幕。' },
    { rank: 3, title: '孤注一掷', en: 'No More Bets', tag: '悬疑', hot: '9.5', desc: '揭秘境外网络诈骗全产业链，张艺兴、金晨演绎被困绝境的人性较量。' },
    { rank: 4, title: '流浪地球2', en: 'The Wandering Earth II', tag: '科幻', hot: '9.4', desc: '太阳危机倒计时，人类命运共同体展开末日求生，国产科幻新高度。' },
    { rank: 5, title: '满江红', en: 'Full River Red', tag: '历史', hot: '9.3', desc: '南宋绍兴年间，宰相秦桧府邸一夜之间暗流涌动，悬念层层递进。' },
    { rank: 6, title: '奥本海默', en: 'Oppenheimer', tag: '传记', hot: '9.2', desc: '诺兰执导，原子弹之父的传奇一生，震撼人心的科学与道德困境。' },
  ];

  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 flex items-center justify-center">
            <i className="ri-fire-line text-2xl text-accent-500"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">本周热映排行榜</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">根据播放热度与影迷口碑实时更新，发现本周最受欢迎的高清大片</p>

        <div className="space-y-3">
          {movies.map((m) => (
            <div
              key={m.rank}
              className="flex items-center gap-3 md:gap-5 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-colors duration-200 cursor-pointer group"
            >
              <div className={`shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center font-heading text-lg md:text-xl font-bold ${
                m.rank <= 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {m.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                    {m.title}
                  </h3>
                  <span className="shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">{m.tag}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-1">{m.desc}</p>
              </div>
              <div className="shrink-0 flex items-center gap-1 text-accent-500 font-bold text-sm md:text-base whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-star-fill text-xs"></i>
                </span>
                {m.hot}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FAQSection() {
  const faqs = [
    { q: '星空电影网是否需要注册才能观看？', a: '不需要。星空电影网全网影片均可免费在线观看，无需注册登录，即点即播，观影零门槛。' },
    { q: '影片画质支持到什么级别？', a: '本站绝大部分影片均支持 1080P 全高清画质播放，热门新片更提供 4K 超清选项，配合智能码率自适应技术，确保流畅不卡顿。' },
    { q: '支持哪些设备观看？', a: '星空电影网全面适配 PC 端、平板及手机浏览器访问，无需安装任何插件或 App，打开网页即可畅享高清观影体验。' },
    { q: '影片更新频率如何？', a: '片库每日更新，最新院线大片、热门剧集第一时间上线。周末及节假日更有专题片单集中推送，确保片源新鲜度。' },
    { q: '观看需要付费吗？', a: '完全免费。星空电影网承诺所有影片永久免费观看，无隐藏收费、无会员门槛，纯正的高清免费电影平台。' },
  ];

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">关于星空电影网的使用，你可能想了解的都在这里</p>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">{faq.q}</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CarouselSection() {
  const features = [
    {
      title: '暑期档强片推荐',
      tag: '热门专题',
      desc: '今年暑期档佳片云集，从国产巨制到好莱坞引进大片，为你精选不容错过的十部必看影片，陪你度过炎炎夏日。',
      img: 'https://readdy.ai/api/search-image?query=Modern%20action%20movie%20cinematic%20scene%20with%20dramatic%20warm%20orange%20and%20teal%20color%20grading%2C%20professional%20cinematography%20lighting%2C%20dynamic%20motion%20composition%2C%20urban%20nighttime%20setting%20with%20neon%20reflections%2C%20film%20grain%20texture%2C%20epic%20movie%20poster%20aesthetic&width=800&height=500&seq=carousel-01&orientation=landscape',
      alt: '暑期档强片推荐',
    },
    {
      title: '成龙动作片特辑',
      tag: '经典回顾',
      desc: '回顾成龙大哥四十余载动作传奇，从《警察故事》到《十二生肖》，每一部都是华语动作片的经典丰碑。',
      img: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20kung%20fu%20film%20aesthetic%20with%20warm%20sepia%20tones%2C%20traditional%20Chinese%20architecture%20details%2C%20martial%20arts%20training%20hall%20with%20wooden%20dummies%2C%20soft%20natural%20window%20light%2C%20nostalgic%20film%20aesthetic%2C%20elegant%20cinematic%20composition&width=800&height=500&seq=carousel-02&orientation=landscape',
      alt: '成龙动作片特辑',
    },
    {
      title: '国产科幻崛起之路',
      tag: '深度专题',
      desc: '从《流浪地球》系列到《独行月球》，国产科幻电影正以惊人的速度崛起，探索属于中国科幻的独特美学与叙事。',
      img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci%20fi%20movie%20concept%20art%20with%20sleek%20spaceship%20interior%2C%20cool%20metallic%20surfaces%2C%20holographic%20displays%2C%20dramatic%20overhead%20lighting%2C%20deep%20space%20visible%20through%20panoramic%20windows%2C%20cinematic%20wide%20shot%2C%20epic%20scale&width=800&height=500&seq=carousel-03&orientation=landscape',
      alt: '国产科幻崛起之路',
    },
    {
      title: '喜剧片精选合集',
      tag: '开心一刻',
      desc: '精选国内外高分喜剧电影，无论开心麻花系列还是经典好莱坞喜剧，总有一部能让你开怀大笑、忘记烦恼。',
      img: 'https://readdy.ai/api/search-image?query=Heartwarming%20comedy%20film%20scene%20with%20bright%20natural%20daylight%2C%20cozy%20family%20living%20room%20setting%2C%20warm%20inviting%20color%20palette%2C%20soft%20diffused%20lighting%20through%20large%20windows%2C%20comfortable%20furniture%20and%20plants%2C%20feel%20good%20atmosphere%2C%20cinematic%20photography&width=800&height=500&seq=carousel-04&orientation=landscape',
      alt: '喜剧片精选合集',
    },
  ];

  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">专题推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">精心策划的电影专题，发现更多值得一看的好片</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div key={i} className="rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-colors duration-200 cursor-pointer group">
              <div className="aspect-[16/10] overflow-hidden bg-secondary-100">
                <img src={f.img} alt={f.alt} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2 whitespace-nowrap">{f.tag}</span>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">{f.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-2xl mx-auto text-center">
        <span className="w-12 h-12 mx-auto flex items-center justify-center mb-4">
          <i className="ri-mail-send-line text-3xl text-primary-500"></i>
        </span>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">联系我们</h2>
        <p className="text-sm text-foreground-500 mb-6">有影片推荐、片源建议或合作意向？欢迎通过以下方式与我们取得联系</p>
        <div className="flex flex-col items-center gap-3 text-sm text-foreground-600">
          <span className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-mail-line text-primary-500"></i></span>
            contact@xingkongmovie.com
          </span>
          <span className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-wechat-line text-primary-500"></i></span>
            微信公众号：星空电影网
          </span>
          <span className="flex items-center gap-2">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-user-voice-line text-primary-500"></i></span>
            片源投稿：submit@xingkongmovie.com
          </span>
        </div>
      </div>
    </section>
  );
}

function CommentsSection() {
  const comments = [
    { name: '影迷小张', time: '2 小时前', rating: 5, text: '星空电影网真的太良心了！画质清晰流畅，片源更新也很快，周末一口气看了三部大片，完美好评！', movie: '速度与激情10' },
    { name: '电影发烧友阿杰', time: '5 小时前', rating: 5, text: '对比了好几个平台，这里的分类做得最清晰，想找动作片一目了然。1080P画质真的惊艳，强烈推荐给大家。', movie: '封神第一部' },
    { name: '周末观影人', time: '8 小时前', rating: 4, text: '片库确实很全，连一些冷门的老片都能找到。如果能加上弹幕功能就更好了，期待平台越做越好！', movie: '孤注一掷' },
    { name: '追剧小达人', time: '1 天前', rating: 5, text: '每天下班回家第一件事就是打开星空电影网看看更新了啥，已经成为我的日常习惯了。免费高清谁不爱呢？', movie: '流浪地球2' },
  ];

  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">影迷热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">来看看影迷朋友们对星空电影网的真实评价</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((c, i) => (
            <div key={i} className="rounded-lg bg-background-50 border border-background-200/70 p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="font-heading text-primary-600 text-sm font-bold">{c.name[0]}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time} · 看过《{c.movie}》</div>
                </div>
                <div className="flex items-center gap-0.5 shrink-0">
                  {Array.from({ length: c.rating }).map((_, j) => (
                    <span key={j} className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-star-fill text-xs text-primary-500"></i></span>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CardsSection() {
  const cards = [
    { title: '碟中谍7：致命清算（上）', tag: '动作', year: '2023', rating: '9.4', img: 'https://readdy.ai/api/search-image?query=Action%20spy%20thriller%20movie%20poster%20style%20with%20dramatic%20urban%20night%20scene%2C%20motorcycle%20chase%20through%20narrow%20European%20streets%2C%20cinematic%20lighting%20with%20orange%20and%20blue%20contrast%2C%20intense%20atmosphere%2C%20professional%20movie%20promotional%20photography&width=600&height=800&seq=card-01&orientation=portrait', alt: '碟中谍7' },
    { title: '巨齿鲨2：深渊', tag: '科幻', year: '2023', rating: '9.1', img: 'https://readdy.ai/api/search-image?query=Deep%20sea%20creature%20feature%20movie%20poster%20style%2C%20massive%20prehistoric%20shark%20emerging%20from%20dark%20ocean%20depths%2C%20dramatic%20underwater%20lighting%20with%20bioluminescent%20glow%2C%20cinematic%20suspense%20aesthetic%2C%20thrilling%20atmosphere&width=600&height=800&seq=card-02&orientation=portrait', alt: '巨齿鲨2' },
    { title: '热烈', tag: '喜剧', year: '2023', rating: '9.3', img: 'https://readdy.ai/api/search-image?query=Street%20dance%20movie%20poster%20style%20with%20vibrant%20urban%20energy%2C%20dancers%20in%20motion%20under%20colorful%20neon%20lights%2C%20warm%20summer%20night%20atmosphere%2C%20youthful%20passion%20and%20movement%2C%20cinematic%20photography%20with%20dynamic%20composition&width=600&height=800&seq=card-03&orientation=portrait', alt: '热烈' },
    { title: '八角笼中', tag: '剧情', year: '2023', rating: '9.2', img: 'https://readdy.ai/api/search-image?query=Boxing%20ring%20drama%20movie%20poster%20style%2C%20intense%20training%20gym%20with%20raw%20concrete%20walls%2C%20dramatic%20spotlight%20on%20boxing%20ring%2C%20gritty%20realistic%20texture%2C%20warm%20amber%20lighting%2C%20powerful%20emotional%20atmosphere&width=600&height=800&seq=card-04&orientation=portrait', alt: '八角笼中' },
    { title: '消失的她', tag: '悬疑', year: '2023', rating: '9.5', img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20style%20with%20enigmatic%20atmosphere%2C%20tropical%20island%20setting%20at%20twilight%2C%20dramatic%20shadows%20and%20silhouettes%2C%20deep%20blue%20and%20teal%20color%20palette%2C%20suspenseful%20cinematic%20lighting%2C%20intriguing%20composition&width=600&height=800&seq=card-05&orientation=portrait', alt: '消失的她' },
    { title: '长安三万里', tag: '动画', year: '2023', rating: '9.6', img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20animated%20movie%20poster%20style%2C%20traditional%20ink%20painting%20aesthetic%20with%20golden%20accents%2C%20poetic%20landscape%20with%20mountains%20and%20rivers%2C%20elegant%20classical%20composition%2C%20warm%20earth%20tones%2C%20cultural%20richness&width=600&height=800&seq=card-06&orientation=portrait', alt: '长安三万里' },
  ];

  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">电影图鉴</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">精选最新热门电影，一张卡片了解一部好片</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cards.map((c, i) => (
            <div key={i} className="rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-colors duration-200 cursor-pointer group">
              <div className="aspect-[3/4] overflow-hidden bg-secondary-100">
                <img src={c.img} alt={c.alt} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-3 md:p-4">
                <div className="flex items-center gap-1.5 mb-1.5">
                  <span className="px-1.5 py-0.5 rounded text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">{c.tag}</span>
                  <span className="text-xs text-foreground-400">{c.year}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">{c.title}</h3>
                <div className="flex items-center gap-1 mt-1.5">
                  <span className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-star-fill text-xs text-primary-500"></i></span>
                  <span className="text-xs font-bold text-primary-600">{c.rating}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function TopicsSection() {
  const topics = [
    { name: '暑期档', count: '2.3k', hot: true },
    { name: '动作大片', count: '1.8k', hot: true },
    { name: '国产电影', count: '1.6k', hot: true },
    { name: '悬疑烧脑', count: '1.4k', hot: false },
    { name: '科幻巨制', count: '1.3k', hot: true },
    { name: '喜剧合家欢', count: '1.2k', hot: false },
    { name: '动画电影', count: '980', hot: false },
    { name: '经典重温', count: '870', hot: false },
    { name: '新片速递', count: '760', hot: true },
  ];

  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">影迷们正在热烈讨论的电影话题，看看大家都在关注什么</p>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t, i) => (
            <span
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-colors duration-200 whitespace-nowrap ${
                t.hot
                  ? 'bg-accent-100 text-accent-700 border border-accent-200/60 hover:bg-accent-200/60'
                  : 'bg-secondary-100 text-secondary-700 border border-secondary-200/60 hover:bg-secondary-200/60'
              }`}
            >
              {t.name}
              <span className={`text-xs font-normal ${t.hot ? 'text-accent-500' : 'text-secondary-500'}`}>{t.count} 讨论</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}


export default function SectionsUpper() {
  return (
    <>
      <RankingSection />
      <FAQSection />
      <CarouselSection />
      <ContactSection />
      <CommentsSection />
      <CardsSection />
      <TopicsSection />
    </>
  );
}

export { RankingSection, FAQSection, CarouselSection, ContactSection, CommentsSection, CardsSection, TopicsSection };